import { IoLocationSharp } from "react-icons/io5";
import { FaPhone } from "react-icons/fa6";
const ContactForm = () => {
  return (
    <div className="w-full px-4 sm:px-6 md:px-10 py-4 sm:py-8 bg-yellow-50/30">
      <div className="flex flex-col items-center justify-center text-center">
        <h2 className="text-2xl md:text-4xl font-serif text-[#92AD36] mt-3">
          Have any Questions ?
        </h2>

        <p className="text-[#848484] mt-3 max-w-2xl leading-relaxed text-sm md:text-base">
          We’d love to hear from you! Whether you have questions about our
          products, need support, or want to explore business opportunities,
          feel free to get in touch with us. Our team is always ready to assist
          you.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 w-full gap-5 mt-10">
        <div className="flex flex-col w-full p-4 border bg-white rounded-xl hover:bg-[#214842] hover:text-white duration-300 hover:scale-105">
          <h2 className="text-base font-semibold text-center hover:text-[#e0d8d8] mt-3">
            Our Office Location
          </h2>
          <p className="text-xs mt-6 leading-relaxed hover:text-[#e0d8d8]tracking-wide flex gap-3">
            <span>
              <IoLocationSharp className="hover:text-[#e0d8d8] mt-3" />
            </span>
            PLOT NO- 5/1,5/2, KHOLADWARA INDUSTRIAL ESTATE, Jatni, Khordha,
            Odisha 752057
          </p>
          <p className="text-xs mt-6 leading-relaxed tracking-wide">
            Our location is easily accessible and conveniently situated to serve
            you better. Visit us to experience our services firsthand and
            connect with our team.
          </p>
        </div>
        <div className="flex flex-col w-full p-4 border bg-white rounded-xl hover:bg-[#214842] hover:text-white duration-300 hover:scale-105">
          <h2 className="text-base font-semibold text-center hover:text-[#e0d8d8] mt-3">
            How can we help ?
          </h2>
          <ul className="text-xs mt-6 leading-7 list-disc list-inside">
            <li>Provide high-quality products tailored to your needs</li>
            <li>Offer expert guidance and support for better results</li>
            <li>Ensure timely delivery and reliable service</li>
            <li>Help improve productivity with sustainable solutions</li>
            <li>
              Provide expert guidance and personalized solutions for your needs
            </li>
          </ul>
        </div>
        <div className="flex flex-col w-full p-4 border bg-white rounded-xl hover:bg-[#214842] hover:text-white duration-300 hover:scale-105">
          <h2 className="text-base font-semibold text-center hover:text-[#e0d8d8] mt-3">
            Our Phone
          </h2>
          <div className="flex gap-3 text-sm mt-6">
            <span>
              <FaPhone className="mt-3" />
            </span>
            <div className="flex flex-col mt-2">
              <span>+91 98539 32961</span>
              {/* <span>+91 91234 56789</span> */}
            </div>
          </div>
          <p className="text-xs mt-6 leading-relaxed tracking-wide">
            Feel free to reach out to us anytime through our contact numbers for
            quick assistance and support. Our team is always ready to answer
            your queries, provide expert guidance, and ensure you get the best
            solutions for your needs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
